
import {typesAddressall} from './svtypes/addrs'
import {SV_SOJ_ORCMOCK_ADDRESS} from '../constants'
const _ = require('lodash')
/*
//http://svabode-1420502022.us-west-1.elb.amazonaws.com/essearch/svuila
//POST http://localhost:8080/essearch/svuila
rq
{
  "query": {
    "match": {
      "sojourn_name": {
        "query": "mancreek",
        "operator": "and"
      }
    }
  }
}



*/
let initStore = {
    loading: false,
    error: false,
    errob :{
      "timestamp": "2015-08-23T02:27:18.038+0000",
      "status": 500,
      "error": "Default Error",
      "message": "500 null",
      "path": "/kk/svaddressDetailPost"
  },
  my_data_geo:{
    "countryTypes": [
        {
            "name": "United STates America",
            "a2": "US",
            "a3": "USA",
            "value": "USA",
            "isonum": "840"
        },
        {
            "name": "Canada",
            "isdcode": "01",
            "a2": "CA",
            "a3": "CAN",
            "value": "CAN",
            "isonum": "124"
        }
    ],
    "stateTypes": [
        {
            "name": "California",
            "value": "CA",
            "a2": "CA"
        },
        {
            "name": "New York",
            "value": "NY",
            "a2": "NY"
        },
        {
            "name": "Texas",
            "value": "TX",
            "a2": "TX"
        }
    ],
    "isdcodeTypes": [
        {
            "name": "United States Of America(+1)",
            "value": "1"
        },
        {
            "name": "Australia(+61)",
            "value": "61"
        },
        {
            "name": "Spain(+34)",
            "value": "34"
        }
    ],
    "genderTypes": [
        {
            "name": "CL_MALE",
            "value": "MALE"
        },
        {
            "name": "CL_FEMALE",
            "value": "FEMALE"
        }
    ]
},
    my_data_addresslist: [{
        "id": 1,
        "fname": "John",
        "lname": "Glen",
        "email": "john123@yahoo.com",
        "address": "12 scotland av",
        "city": "Albany",
        "state": "New York",
        "zip": "12110",
        "country": "USA",
        "isdcode": "+1",
        "phone": "5121234356"
    },{
      "id": 2,
        "fname": "Alen",
        "lname": "White",
        "email": "allen123@yahoo.com",
        "address": "12 scotland av",
        "city": "Albany",
        "state": "New York",
        "zip": "12110",
        "country": "USA",
        "isdcode": "+1",
        "phone": "5121234357"
    },{
      "id": 3,
        "fname": "Lucas",
        "lname": "Glen",
        "email": "lucas123@yahoo.com",
        "address": "12 scotland av",
        "city": "Albany",
        "state": "New York",
        "zip": "12110",
        "country": "USA",
        "isdcode": "+1",
        "phone": "5121234358"
    },{
      "id": 4,
        "fname": "Peter",
        "lname": "Glen",
        "email": "pet123@yahoo.com",
        "address": "12 scotland av",
        "city": "Albany",
        "state": "New York",
        "zip": "12110",
        "country": "USA",
        "isdcode": "+1",
        "phone": "5121234352"
    }
    
    ]
}

export default (state = initStore, action) => {
    console.log(action);
    let januState, svns;
    switch (action.type) {
        case "sojourns/LIST_SOJOURNS":

     console.log('tasks LIST_SOJOURNS reducer')
     
    
      console.log(svns)
      if(Array.isArray(action.sojourns) && (action.sojourns.length >0)){
       
        state.sojourns =_.clone(action.sojourns)
      }
     svns = Object.assign({}, state, {sojourns:action.sojourns})
      console.log('sv reduce --for LIST_TASKS')
      console.log(svns)

      return svns
        case "GET_ADDRESSALL_SUCCESS":
            console.log("reduce %%%%%%%%evsearcg  success*****************");
            console.log(action.payload.my_data_addresslist);
            // let januState = {...state, loading: false, my_data_addresslist: action.payload.my_data_addresslist}
             januState = {...state, error:false, loading: false,my_data_geo:action.payload.my_data_geo, my_data_addresslist: action.payload.my_data_addresslist, svr_soj_images: action.payload.my_images}
            return januState
       
        case typesAddressall.GET_ADDRESSALL_BEGIN:
            console.log("loading")
            return {...state, loading: true}
        case typesAddressall.GET_ADDRESSALL_ERROR:
          console.log("error")
          console.log(action.payload.errob)
          const errjson = {
              "timestamp": "2024-08-23T02:27:18.038+0000",
              "status": 500,
              "error": "Internal Server Error",
              "message": "500 null",
              "path": "/accountclient/svaddressDetailPost"
          }
          return {...state,errob:action.payload.errob, error: true}
   
           
        default:
            return state
    }
}